import { format, isDate, parseISO } from "date-fns";

export function formatDate(date) {
    if (typeof date === "string" && isDate(parseISO(date))) return format(parseISO(date), "dd.MM.yyyy");
    if (isDate(date)) return format(date, "dd.MM.yyyy");
    return date;
}
